module.exports = __webpack_public_path__ + "static/media/pn_billboard_banner_default_375@2x.ef75c4f2.png";